// @flow
import React from 'react';
import PropTypes from 'prop-types';

import PreviewIcon from '../icons/preview/PreviewComponent';
import CloseIcon from '../icons/close/CloseComponent';

import './Search.scss';

type Props = {
  value?: string,
  placeholder?: string,
  onSearchCallback?: Function,
};

type SearchEvent = {
  keyCode: number,
  preventDefault: Function,
};

type ClickEvent = SearchEvent & { persist: Function };

const ENTER_KEY: number = 13;
const SEARCH_MIN_LENGTH: number = 2;

/**
 * Displays a SearchBox with a callback on text entered
 */
class SearchComponent extends React.Component {
  constructor(props: Props): void {
    super(props);
    this.searchBox = null;
    this.state = {
      inputText: this.props.value || '',
    };
  }

  UNSAFE_componentWillReceiveProps(newProps: Props): void {
    // Sets the correct value when either the current or previous state is empty
    const isEmptyValue = newProps.value === '';
    const isEmptyTypedText = this.state.inputText === '';
    if ((isEmptyValue && !isEmptyTypedText) || (!isEmptyValue && isEmptyTypedText)) {
      this.setState({
        inputText: newProps.value,
      });
    }
  }

  onSearch = (event: SearchEvent): void => {
    event.preventDefault();
    this.searchBox.blur();
    this.props.onSearchCallback(this.state.inputText);
  };

  onClick = (event: ClickEvent): void => {
    event.persist();

    if (this.state.inputText.length) {
      this.setState(
        {
          inputText: '',
        },
        () => {
          if (this.state.inputText !== this.props.value) {
            this.onSearch(event);
          }
        },
      );
    }
  };

  onTextInput = (event: { target: { value: string } }): void => {
    const newInputValue = event.target.value;

    this.setState({
      inputText: newInputValue,
    });
  };

  onSearchSubmit = (event: SearchEvent): void => {
    if (event.keyCode === ENTER_KEY && this.state.inputText.length >= SEARCH_MIN_LENGTH) {
      event.preventDefault();
      this.onSearch(event);
    }
  };

  render(): Element {
    const hasInputClass = this.state.inputText.length ? 'search-component--input' : '';
    return (
      <div className="search-component">
        <label htmlFor="search-box" className="search-component__label">
          {this.props.value || this.props.placeholder}
        </label>
        <input
          id="search-box"
          type="search"
          ref={(component) => {
            this.searchBox = component;
          }}
          className="search-component__input"
          value={this.state.inputText}
          placeholder={this.props.placeholder}
          onChange={this.onTextInput}
          onKeyUp={this.onSearchSubmit}
        />
        <span className={`search-component__icon ${hasInputClass}`} onClick={this.onClick}>
          {this.state.inputText.length ? <CloseIcon /> : <PreviewIcon />}
        </span>
      </div>
    );
  }
}

SearchComponent.displayName = 'Search';

SearchComponent.propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onSearchCallback: PropTypes.func,
};

SearchComponent.defaultProps = {
  placeholder: '',
  onSearchCallback: () => null,
};

export default SearchComponent;
